<template>
    <template v-if="tariffs?.length > 0">
        <h1 class="pt-8 pb-4 container mx-auto font-bold text-paragraph text-2xl text-center">{{ title }}</h1>
        <TariffOfferList :tariffs="tariffs" :linkText="linkText" :linkPath="linkPath"/>
    </template>
</template>

<script setup lang="ts">
import type { Tariff } from '~~/models/Tariff/Tariff';

interface Props {
    tenantId: string;
    contractRenewal?: boolean;
    contentPageOnly?: boolean;
    student?: boolean;
    subTenant?: boolean;
    mobile?: boolean; 
    refurbishedHighlights?: boolean;
    title: string;
    store: any;
    linkText?: string;
    linkPath?: string;
    allMobile?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    contractRenewal: false,
    contentPageOnly: false,
    refurbishedHighlights: false,
    student: false,
    allMobile: false
});

const PAGE_SIZE: number = 500; // Pagination, Lazy Loading, ...?
const tariffs = ref<Tariff[]>([]);

const fetchTariffs = async (storeId: string): Promise<void> => {
    
    let queryExtra: Record<string, any> = {};

    if (props.allMobile) {
        queryExtra = {
            contractRenewal: props.contractRenewal,
            contentPageOnly: props.contentPageOnly,
            refurbishedHighlights: props.refurbishedHighlights,
            student: props.student
        };
    } else if (props.mobile) {
        queryExtra = {
            pageSize: PAGE_SIZE,
            mobile: props.mobile,
            subTenant: props.subTenant,
            refurbishedHighlights: props.refurbishedHighlights
        };
    } else if (props.contractRenewal) {
        queryExtra = {
            contractRenewal: props.contractRenewal
        };
    } else if (props.student) {
        queryExtra = {
            student: props.student
        };
    } else if (props.refurbishedHighlights) {
        queryExtra = {
            refurbishedHighlights: props.refurbishedHighlights
        };
    } else {
        queryExtra = {
            contractRenewal: props.contractRenewal,
            contentPageOnly: props.contentPageOnly,
            refurbishedHighlights: props.refurbishedHighlights,
            student: props.student,
            subTenant: props.subTenant,
            mobile: props.mobile
        };
    }
    
    const { data } = await useFetch<{ items: Tariff[] }>(
        `/api/nea/tariff-service/tenants/${props.tenantId}/tariffs/store/${storeId}`,
        {
            query: {
                validOnly: true,
                sortBy: ['priority', 'validFrom'],
                sort: ['asc', 'asc'],
                pageSize: PAGE_SIZE,
                ...queryExtra
            },
            cache: 'no-cache'
        }
    );
    
    tariffs.value = data.value?.items ?? [];

    console.log(queryExtra);
}

await fetchTariffs(props.store?.id);

watch(
    () => props.store,
    async (store) => {
        const storeId: string = store?.id;
        if (!storeId) {
            return;
        }

        await fetchTariffs(storeId);
    }
);

</script>
<style scoped>
.tariff-offers {
    & .short-description ul {
        & li {
            @apply relative flex items-center gap-2 before:w-1.5 before:h-1.5 before:inline-block before:rounded-full before:bg-black before:left-0;
        }
    }

    & a {
        @apply text-primary;
    }
}

label {
    @apply font-bold;
}
</style>